import React from 'react';
import './Footer.css'
const Footer = () => {
    return (
        <div className="bg-dark pt-5 ">
            <div  className="container footer bg-dark p-5 " fixed="bottom">
            <div className="row">
              <div className="col">
                  <h5>About MedicalPress</h5>
                  <p>Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>
                  <p>
                  consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet das.
                  </p>
              </div>
              <div className="col">
               <h5>Latest Tweets</h5>
               Try using Real Estate CRM Plugin <br/>
               - RealHomes Theme! . . <br/>
               #InspiryThemes #RealHomes <br/>
               #RealEstate <br/>
               #WordPressTheme… <br/>
               <a href="https://t.co/RMOG70PK2u">https://t.co/RMOG70PK2u</a> <br/>
               - Friday Apr 10 - 11:07am <br/>
               <p></p>
               Version 4.0.3 of Food Recipes <br/>
               Theme is available for download. <br/>
                <a href="https://t.co/zVVZIQI9zq">https://t.co/zVVZIQI9zq</a>  <br/>
                <a href="https://t.co/z161IyjKUz">https://t.co/z161IyjKUz</a>  <br/>
               - Sunday Mar 29 - 6:23am <br/>
              </div>
              <div className="col">
                 <h5>Newsletter Sign Up</h5>
                 <p>Stay updated with latest news from Medical Press.</p>
                 <form action="">
                 <label for="exampleInputEmail1" className="form-label">Email address</label>
    <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"/>

    <label for="exampleInputPassword1" className="form-label">Password</label>
    <input type="password" className="form-control" id="exampleInputPassword1"/><br />
    <button className="btn btn-danger">Submit</button>
                 </form>
              </div>
              
            </div>
            <br />
            <br />
            <div className="d-flex justify-content-between">
                <div><h4>© Copyright 2019. All Rights Reserved by Medical Press</h4>

</div>
                <div>
                <i className="fab fa-twitter-square mx-2 fa-2x"></i>
                <i className="fab fa-facebook-square mx-2 fa-2x"></i>
                <i className="fab fa-google-plus-square mx-2 fa-2x"></i>
                <i className="fab fa-youtube mx-2 fa-2x"></i>
                <i className="fab fa-instagram mx-2 fa-2x"></i>
                <i className="fab fa-whatsapp-square mx-2 fa-2x"></i>

                </div>
            </div>
            </div>
        </div>
    );
};

export default Footer;